import { useState } from 'react'

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

const COLUMNS = 3
const ROWS_PER_PAGE = 5
const ORGS_PER_PAGE = COLUMNS * ROWS_PER_PAGE

type OrganizationNamesTableProps = Readonly<{
  organizationNames: ReadonlyArray<string>
}>

export const OrganizationNamesTable: React.FC<OrganizationNamesTableProps> = ({
  organizationNames,
}) => {
  const { t } = useTranslation()
  const [page, setPage] = useState(0)

  const pageNames = organizationNames.slice(page * ORGS_PER_PAGE, (page + 1) * ORGS_PER_PAGE)

  const rows = Array.from({ length: ROWS_PER_PAGE }, (_, rowIndex) =>
    pageNames.slice(rowIndex * COLUMNS, (rowIndex + 1) * COLUMNS),
  )

  return (
    <TableContainer>
      <Table size="small" className="borderless" sx={{ tableLayout: 'fixed' }}>
        <TableBody data-testid="organization-names-table">
          {rows.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {Array.from({ length: COLUMNS }, (_, columnIndex) => {
                const name = row[columnIndex]
                return (
                  <TableCell key={columnIndex} sx={{ width: `${100 / COLUMNS}%` }}>
                    <Typography variant="body1" noWrap title={name}>
                      {name || '\u00A0'}
                    </Typography>
                  </TableCell>
                )
              })}
            </TableRow>
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              data-testid="organization-names-table-pagination"
              colSpan={COLUMNS}
              page={page}
              rowsPerPage={ORGS_PER_PAGE}
              rowsPerPageOptions={[]}
              count={organizationNames.length}
              showFirstButton
              showLastButton
              onPageChange={(_event, nextPage) => setPage(nextPage)}
              getItemAriaLabel={(type) => t(`global.pagination.${type}`)}
              labelDisplayedRows={({ from, to, count }) =>
                t('global.pagination.of', { from, to, count })
              }
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  )
}
